/** Тексты окна: Выбор усиления «1 из 3». */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.boost.cleared": "Wave {n} clear!",
  "win.boost.title": "Choose a boost",
  "win.boost.hint": "Take this one",
  "win.boost.taken": "Taken {n}/{max}",
  "win.boost.rarity.common": "Common",
  "win.boost.rarity.rare": "Rare",
  "win.boost.rarity.epic": "Epic",
  "boost.damage_up.name": "More Damage",
  "boost.damage_up.description": "+15% hero damage",
  "boost.fire_rate.name": "Rapid Fire",
  "boost.fire_rate.description": "+12% fire rate",
  "boost.long_range.name": "Long Range",
  "boost.long_range.description": "+1 cell range",
  "boost.crit_chance.name": "Sharp Eye",
  "boost.crit_chance.description": "+5% crit chance",
  "boost.cannon_power.name": "Heavy Shells",
  "boost.cannon_power.description": "+25% cannon damage",
  "boost.hq_armor.name": "Armor Plates",
  "boost.hq_armor.description": "+20% base HP",
  "boost.coin_rush.name": "Coin Rush",
  "boost.coin_rush.description": "+15% coins",
  "boost.quick_skills.name": "Quick Skills",
  "boost.quick_skills.description": "−10% skill cooldown",
  "boost.ignite.name": "Ignite",
  "boost.ignite.description": "Hits burn: 8 dmg/s for 3s",
  "boost.crit_damage.name": "Crusher",
  "boost.crit_damage.description": "+50% crit damage",
  "boost.ricochet.name": "Ricochet",
  "boost.ricochet.description": "Shots bounce to 1 more zombie",
  "boost.cannon_rapid.name": "Rapid Cannon",
  "boost.cannon_rapid.description": "+30% cannon fire rate",
  "boost.hq_regen.name": "Repair Crew",
  "boost.hq_regen.description": "Base regenerates HP",
  "boost.multishot.name": "Multishot",
  "boost.multishot.description": "+1 projectile per shot",
  "boost.skill_power.name": "Skill Power",
  "boost.skill_power.description": "+25% skill power",
  "boost.frost_aura.name": "Frost Aura",
  "boost.frost_aura.description": "Zombies 15% slower",
  "boost.overdrive.name": "Overdrive",
  "boost.overdrive.description": "+30% damage, +20% fire rate",
  "boost.endless_damage.name": "Endless Fury",
  "boost.endless_damage.description": "+3% damage, no limit",
  "boost.endless_armor.name": "Endless Plating",
  "boost.endless_armor.description": "+4% base durability, no limit",
  "boost.endless_coins.name": "Endless Income",
  "boost.endless_coins.description": "+3% coins, no limit",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.boost.cleared": "Волна {n} пройдена!",
  "win.boost.title": "Выбери усиление",
  "win.boost.hint": "Бери это",
  "win.boost.taken": "Взято {n}/{max}",
  "win.boost.rarity.common": "Обычное",
  "win.boost.rarity.rare": "Редкое",
  "win.boost.rarity.epic": "Эпическое",
  "boost.damage_up.name": "Больше урона",
  "boost.damage_up.description": "+15 % урона героев",
  "boost.fire_rate.name": "Быстрая стрельба",
  "boost.fire_rate.description": "+12 % к темпу",
  "boost.long_range.name": "Дальнобой",
  "boost.long_range.description": "+1 клетка дальности",
  "boost.crit_chance.name": "Меткость",
  "boost.crit_chance.description": "+5 % шанс крита",
  "boost.cannon_power.name": "Тяжёлые ядра",
  "boost.cannon_power.description": "+25 % урона пушки",
  "boost.hq_armor.name": "Бронеплиты",
  "boost.hq_armor.description": "+20 % прочности штаба",
  "boost.coin_rush.name": "Монетный дождь",
  "boost.coin_rush.description": "+15 % монет",
  "boost.quick_skills.name": "Быстрые навыки",
  "boost.quick_skills.description": "−10 % перезарядки навыков",
  "boost.ignite.name": "Поджог",
  "boost.ignite.description": "Попадания жгут: 8 урона/с, 3 с",
  "boost.crit_damage.name": "Сокрушение",
  "boost.crit_damage.description": "+50 % урона крита",
  "boost.ricochet.name": "Рикошет",
  "boost.ricochet.description": "Снаряд отскакивает ещё в 1 зомби",
  "boost.cannon_rapid.name": "Скорострельная пушка",
  "boost.cannon_rapid.description": "+30 % к темпу пушки",
  "boost.hq_regen.name": "Ремонтная бригада",
  "boost.hq_regen.description": "Штаб восстанавливает прочность",
  "boost.multishot.name": "Мультивыстрел",
  "boost.multishot.description": "+1 снаряд за выстрел",
  "boost.skill_power.name": "Мощь навыков",
  "boost.skill_power.description": "+25 % силы навыков",
  "boost.frost_aura.name": "Ледяная аура",
  "boost.frost_aura.description": "Зомби медленнее на 15 %",
  "boost.overdrive.name": "Форсаж",
  "boost.overdrive.description": "+30 % урона и +20 % темпа",
  "boost.endless_damage.name": "Вечная ярость",
  "boost.endless_damage.description": "+3 % урона, без предела",
  "boost.endless_armor.name": "Вечная броня",
  "boost.endless_armor.description": "+4 % прочности штаба, без предела",
  "boost.endless_coins.name": "Вечный доход",
  "boost.endless_coins.description": "+3 % монет, без предела",
};

const uk: Record<Key, string> = {
  "win.boost.cleared": "Хвилю {n} пройдено!",
  "win.boost.title": "Обери підсилення",
  "win.boost.hint": "Бери це",
  "win.boost.taken": "Узято {n}/{max}",
  "win.boost.rarity.common": "Звичайне",
  "win.boost.rarity.rare": "Рідкісне",
  "win.boost.rarity.epic": "Епічне",
  "boost.damage_up.name": "Більше шкоди",
  "boost.damage_up.description": "+15 % шкоди героїв",
  "boost.fire_rate.name": "Швидка стрільба",
  "boost.fire_rate.description": "+12 % до темпу",
  "boost.long_range.name": "Далекобій",
  "boost.long_range.description": "+1 клітинка дальності",
  "boost.crit_chance.name": "Влучність",
  "boost.crit_chance.description": "+5 % шанс криту",
  "boost.cannon_power.name": "Важкі ядра",
  "boost.cannon_power.description": "+25 % шкоди гармати",
  "boost.hq_armor.name": "Бронеплити",
  "boost.hq_armor.description": "+20 % міцності штабу",
  "boost.coin_rush.name": "Монетний дощ",
  "boost.coin_rush.description": "+15 % монет",
  "boost.quick_skills.name": "Швидкі навички",
  "boost.quick_skills.description": "−10 % перезаряджання навичок",
  "boost.ignite.name": "Підпал",
  "boost.ignite.description": "Влучання палять: 8 шкоди/с, 3 с",
  "boost.crit_damage.name": "Трощення",
  "boost.crit_damage.description": "+50 % шкоди криту",
  "boost.ricochet.name": "Рикошет",
  "boost.ricochet.description": "Снаряд відскакує ще в 1 зомбі",
  "boost.cannon_rapid.name": "Скорострільна гармата",
  "boost.cannon_rapid.description": "+30 % до темпу гармати",
  "boost.hq_regen.name": "Ремонтна бригада",
  "boost.hq_regen.description": "Штаб відновлює міцність",
  "boost.multishot.name": "Мультипостріл",
  "boost.multishot.description": "+1 снаряд за постріл",
  "boost.skill_power.name": "Міць навичок",
  "boost.skill_power.description": "+25 % сили навичок",
  "boost.frost_aura.name": "Крижана аура",
  "boost.frost_aura.description": "Зомбі повільніші на 15 %",
  "boost.overdrive.name": "Форсаж",
  "boost.overdrive.description": "+30 % шкоди і +20 % темпу",
  "boost.endless_damage.name": "Вічна лють",
  "boost.endless_damage.description": "+3 % шкоди, без межі",
  "boost.endless_armor.name": "Вічна броня",
  "boost.endless_armor.description": "+4 % міцності штабу, без межі",
  "boost.endless_coins.name": "Вічний дохід",
  "boost.endless_coins.description": "+3 % монет, без межі",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
